<ui-panel class="activity-timeline-panel" width="fill" panelTitle="Activity Timeline" title="Activity Timeline">
  <div *ngIf="isLoading()" class="state loading" data-testid="loading-state">
    Loading activity timeline
  </div>

  <div *ngIf="!isLoading() && errorState() as error" class="state error" data-testid="error-state">
    <strong>{{ error.title }}</strong>
    <p *ngFor="let message of error.messages" class="message">{{ message }}</p>
  </div>

  <ng-container *ngIf="!isLoading() && !errorState()">
    <p *ngIf="isUnavailable()" class="message" data-testid="activity-unavailable">
      No activity has been recorded for this candidate yet.
    </p>

    <ol *ngIf="!isUnavailable()" class="events" data-testid="activity-list">
      <li
        *ngFor="let event of events(); trackBy: trackByEvent"
        class="event"
        [attr.data-event-type]="event.eventTypeCode"
        [attr.data-source]="event.sourceCode"
      >
        <div class="event__header">
          <span class="event__label">{{ event.label }}</span>
          <span class="event__when">{{ formatWhen(event) }}</span>
        </div>
        <p *ngIf="formatReason(event.reasonCode) as reason" class="event__reason">{{ reason }}</p>
      </li>
    </ol>
  </ng-container>
</ui-panel>
